export class QuarantineSampleRow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "values",
            "baseName": "values",
            "type": "{ [key: string]: string | null; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QuarantineSampleRow.attributeTypeMap;
    }
    constructor() {
    }
}
